import { sendWebexEvent, setWebExUserAttributes } from '@klv/context/experimentation/utils';
import type { IInitialFormValues, TFormType } from '../types';

const trackSignupSubmission = (url: string) => {
  fetch('/request-mkt/process/signup-form-success', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      url,
    }),
  }).catch((error) => {
    console.error('Error calling signup form success tracker:', error);
  });
};

const handleSuccess = (values: IInitialFormValues, form: TFormType) => {
  window?.heap?.track?.('Marketing Form Success', {
    emailAddress: values?.email ?? '',
    formName: form,
    host: process.env.GATSBY_HOST ?? '',
  });

  setWebExUserAttributes({
    hasSubmittedForm: true,
    [`${form}FormComplete`]: true,
  });

  if (form === 'demo') {
    sendWebexEvent('global_conversion_get_a_demo_eng');
  } else if (form === 'signup') {
    sendWebexEvent('global_conversion_sign_up_eng');
    
    // Track successful signup submission
    trackSignupSubmission(window.location.href);
  }
};

export default handleSuccess;
